module.exports = __webpack_public_path__ + "img/Pro-3.fba7b8d7.jpg";